export enum TermsOfDelivery {
  CustomsCostsForCustomer = "DAP",
  CustomsCostForOwnAccount = "DDP",
}
